import { daysSince } from "#/utils/dateTimeUtils";
import { useTranslation } from "react-i18next";

interface LastMovedTextProps {
  date?: string | Date | null;
}

/**
 * Renders how long ago an item last changed status as a relative day count
 * (e.g. "today", "1 day ago", "5 days ago"). Shows "--" when the date is
 * missing (item/category never moved).
 */
const LastMovedText = ({ date }: LastMovedTextProps) => {
  const { t } = useTranslation();
  const days = daysSince(date);

  if (days === null) return <>--</>;

  return <>{t("common.daysAgo", { count: days })}</>;
};

export default LastMovedText;
